// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
    theme: {
      // defaultTheme: 'light',
      themes: {
        light: {
          // primary: '#F8AFA6',  // Example brand color 1
          // secondary: '#FACCC7',  // Example brand color 2
          // accent: '#4CAF50',  // Example brand color 3
          // Add other custom colors here
          colors: {
            PinkDoorPrimary: '#FACCC7',  
            PinkDoorSecondary: '#F8AFA6',
          }
        },
        dark: {
          // primary: '#F8AFA6',  // You can also define colors for dark theme
          colors: {
            PinkDoorPrimary: '#FACCC7',  
            PinkDoorSecondary: '#F8AFA6',
          }
        }
      },
    },
});
